import { Injectable } from '@angular/core';
import { Theme } from '../models/Theme';
import {
  ensureContrastOnBackground,
  hasReadableContrastOnWhite,
  hexToRgbString,
  normalizeHexColor,
} from '../utils/color-contrast.util';
import { MetadataService } from './metadata.service';

const LIGHT_SURFACE = '#ffffff';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  constructor(private metadataService: MetadataService) { }

  public setTheme(): void {
    const theme: Theme = this.metadataService.getThemeMetadataFromCache();

    if (!theme) return;

    this.setColors(theme);
  }

  private setColors(theme: Theme): void {
    if (theme.Css_Color_Primary === 'white' && theme.Css_Color_Secondary === 'white') return;

    this.applyPalette('primary', theme.Css_Color_Primary, theme.Css_Color_Primary_Contrast, theme.Css_Color_Primary_Tint, theme.Css_Color_Primary_Shade);
    this.applyPalette('secondary', theme.Css_Color_Secondary, theme.Css_Color_Secondary_Contrast, theme.Css_Color_Secondary_Tint, theme.Css_Color_Secondary_Shade);
    this.applyPalette('tertiary', theme.Css_Color_Tertiary, theme.Css_Color_Tertiary_Contrast, theme.Css_Color_Tertiary_Tint, theme.Css_Color_Tertiary_Shade);

    document.body.style.setProperty('--logifit-color-background', theme.Css_BackgroundColor);
  }

  private applyPalette(
    name: 'primary' | 'secondary' | 'tertiary',
    color: string,
    contrast: string,
    tint: string,
    shade: string,
  ): void {
    const prefix = `ion-color-${name}`;
    const brandColor = normalizeHexColor(color) ?? color;
    const onLight = ensureContrastOnBackground(brandColor, LIGHT_SURFACE);
    const contrastOnBrand = ensureContrastOnBackground(contrast || '#ffffff', brandColor);

    document.body.style.setProperty(`--${prefix}`, brandColor);
    document.body.style.setProperty(`--${prefix}-rgb`, hexToRgbString(brandColor));
    document.body.style.setProperty(`--${prefix}-contrast`, contrastOnBrand);
    document.body.style.setProperty(`--${prefix}-tint`, tint);
    document.body.style.setProperty(`--${prefix}-shade`, shade);
    document.body.style.setProperty(`--${prefix}-on-light`, onLight);
    document.body.style.setProperty(`--${prefix}-on-light-rgb`, hexToRgbString(onLight));

    if (name === 'primary') {
      document.body.style.setProperty('--ds-color-brand', onLight);
      document.body.style.setProperty('--ds-color-brand-rgb', hexToRgbString(onLight));
      document.body.style.setProperty(
        '--ds-color-brand-needs-adjustment',
        hasReadableContrastOnWhite(brandColor) ? '0' : '1',
      );
    }
  }
}
